// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PublicSchemaTypes from '../../../graphql/public/PublicSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type LoginPageQueryVariables = PublicSchemaTypes.Exact<{ [key: string]: never; }>;


export type LoginPageQuery = (
  { __typename?: 'Query' }
  & { organisation?: PublicSchemaTypes.Maybe<(
    { __typename?: 'OrganisationModelGQLBase' }
    & Pick<PublicSchemaTypes.OrganisationModelGqlBase, 'id' | 'only_sso_login' | 'billing_status' | 'allow_signup' | 'name' | 'can_students_update_profile'>
    & { features: (
      { __typename?: 'OrganisationFeatures' }
      & Pick<PublicSchemaTypes.OrganisationFeatures, 'account_name_login' | 'instant_sso_login'>
    ), additionalFieldsConfig?: PublicSchemaTypes.Maybe<(
      { __typename?: 'AdditionalFieldsConfigRecord' }
      & Pick<PublicSchemaTypes.AdditionalFieldsConfigRecord, 'privacyPolicyEnabled' | 'privacyPolicyUrl' | 'additionalFields'>
    )>, accountNameLoginConfig?: PublicSchemaTypes.Maybe<(
      { __typename?: 'OrganisationAccountNameLoginConfigModel' }
      & { fields_config?: PublicSchemaTypes.Maybe<(
        { __typename?: 'FieldsConfigRecord' }
        & Pick<PublicSchemaTypes.FieldsConfigRecord, 'verificationFields'>
      )> }
    )> }
  )> }
);


export const LoginPageDocument = gql`
    query loginPage {
  organisation {
    id
    only_sso_login
    billing_status
    allow_signup
    name
    features {
      account_name_login
      instant_sso_login
    }
    can_students_update_profile
    additionalFieldsConfig {
      privacyPolicyEnabled
      privacyPolicyUrl
      additionalFields
    }
    accountNameLoginConfig {
      fields_config {
        verificationFields
      }
    }
  }
}
    `;

/**
 * __useLoginPageQuery__
 *
 * To run a query within a React component, call `useLoginPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoginPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoginPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useLoginPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LoginPageQuery, LoginPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LoginPageQuery, LoginPageQueryVariables>(LoginPageDocument, options);
      }
export function useLoginPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LoginPageQuery, LoginPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LoginPageQuery, LoginPageQueryVariables>(LoginPageDocument, options);
        }
export type LoginPageQueryHookResult = ReturnType<typeof useLoginPageQuery>;
export type LoginPageLazyQueryHookResult = ReturnType<typeof useLoginPageLazyQuery>;
export type LoginPageQueryResult = Apollo.QueryResult<LoginPageQuery, LoginPageQueryVariables>;